import { useState } from "react";

/**
 * Compact logo strip shown on the candidate exam page. Kept small (~40px tall)
 * so it doesn't compete with the question area or the timer. Hides itself if
 * /logo-strip.png can't be loaded.
 */
export function ExamLogo() {
  const [hide, setHide] = useState(false);
  if (hide) return null;

  return (
    <div className="border-b border-brand-ink/10 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-3xl items-center justify-center px-4 py-2">
        <img
          src="/logo-strip.png"
          alt="Baba Farid Group of Institutions"
          className="h-10 w-auto object-contain"
          onError={() => setHide(true)}
        />
      </div>
    </div>
  );
}
